import { Avatar, Grid, makeStyles, Paper, Typography, useTheme } from '@material-ui/core'
import React from 'react'
import { RichTextViewer } from '../../../../../components/richTextViewer/richTextViewer'
import { styles } from '../commenListCard.styles'

export interface CommentListItemProps {
  date: string
  description: string
  imgPath: string
  user: string
}

export const CommentListItem: React.FC<CommentListItemProps> = ({
  date,
  description,
  imgPath,
  user
}) => {
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()
  // #region Handlers Starts
  // #endregion Handlers Ends

  // #region Functions Starts
  // #endregion Functions Ends

  // #region Form Definition Starts
  // #endregion Form Definition Ends

  // #region DataTable Config Starts
  // #endregion DataTable Config Ends

  // #region Hooks Starts
  // #endregion Hooks Ends

  return (
    <Paper className={classes.commentListItem}>
      <Grid container wrap="nowrap" spacing={2}>
        <Grid item>
          <Avatar alt="?" src={imgPath} />
        </Grid>
        <Grid item xs zeroMinWidth>
          <Typography variant="h5" className={classes.userItem}>
            {user === 'SYSTEM' ? 'Globalsyde' : user}
          </Typography>
          <Typography variant="body2" className={classes.descriptionItem}>
            <RichTextViewer content={description} />
          </Typography>
          <Typography className={classes.dateItem}> {date}</Typography>
        </Grid>
      </Grid>
    </Paper>
  )
}
